import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Instagram icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Instagram } from '@sravni/design-system-icons'
 *
 * <Instagram />
 * ```
 */
var Instagram = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Instagram", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2c-2.172 0-2.445.01-3.298.048-.852.04-1.433.174-1.942.372a3.917 3.917 0 0 0-1.417.922A3.927 3.927 0 0 0 2.42 4.76c-.199.51-.333 1.09-.372 1.942C2.01 7.555 2 7.827 2 10s.01 2.444.048 3.298c.04.851.174 1.433.372 1.941.205.527.478.973.923 1.418.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C7.555 17.99 7.827 18 10 18s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.915 3.915 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.51.332-1.09.372-1.942.038-.853.048-1.125.048-3.298s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417 3.911 3.911 0 0 0-1.417-.923c-.51-.198-1.092-.333-1.943-.372C12.443 2.01 12.172 2 9.998 2h.003Zm4.271 2.77a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92Zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217Zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334Z", fill: "currentColor" }))); });

export { Instagram };
//# sourceMappingURL=Instagram.js.map
